"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
export default React.createClass({
  render: function() {
    const disabledClassName = this.props.disabledClassName || "button--disabled";
    const className = this.props.disabled ? disabledClassName : this.props.className;
    const onClick = this.props.disabled ? null : this.props.onClick;
    return /* @__PURE__ */ React.createElement(
      "button",
      __spreadProps(__spreadValues({}, this.props), {
        disabled: this.props.disabled,
        onClick,
        className
      }),
      this.content()
    );
  },
  content: function() {
    if (this.props.disabled) {
      return this.props.disabledText;
    } else {
      return this.props.children;
    }
  }
});
